/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocPlusIcon16Solid = forwardRef('DocPlusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 1H8v3.5A1.5 1.5 0 0 0 9.5 6H13v6.5a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 12.5v-9A2.5 2.5 0 0 1 4.5 1Zm3.625 7.246a.625.625 0 1 0-1.25 0V9.87H5.252a.625.625 0 1 0 0 1.25h1.623v1.624a.625.625 0 1 0 1.25 0V11.12h1.623a.625.625 0 0 0 0-1.25H8.125V8.245Z" }),
        React.createElement("path", { d: "M13 4.99V5H9.5a.5.5 0 0 1-.5-.5V1h.01L13 4.99Z" })));
});
